import React, { useEffect, useState } from "react";
import PrivateLayout from "../../layouts/privateLayout";
import { Box, Container, Grid, Link } from "@mui/material";
import BasicBreadcrumbs from "../../components/breadcrumb";
import DetailsUserForm from "./detailsUserForm";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { userData } from "../../data/userData";
import { Link as RouterLink } from "react-router-dom";
import ErrorAlert from "../../helper/errorAlert";
import { useApiClient } from "../../context/ApiClientContext";
import api from "../../helper/baseApi";
import ActivityListing from "../../components/activityListing";
import UserPointBox from "./userPoint";

const ViewDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const [mode, setMode] = useState("view");
  const [userDetails, setUserDetails] = useState({});
  const navigate = useNavigate();

  const { apiUrls: { mobileApiUrl } } = useApiClient();


  const activities = {
    today: [
      {
        email: "yp.loo@gosumgroup.com",
        action: "submit mission",
        time: "2 hours ago",
      },
      {
        email: "yp.loo@gosumgroup.com",
        action: "liked the event",
        time: "6 hours ago",
      },
      {
        email: "yp.loo@gosumgroup.com",
        action: "liked the event",
        time: "8 hours ago",
      },
      {
        email: "yp.loo@gosumgroup.com",
        action: "liked the event",
        time: "8 hours ago",
      },
      {
        email: "yp.loo@gosumgroup.com",
        action: "submit mission",
        time: "12 hours ago",
        image: "https://picsum.photos/60/40?1",
      },
    ],
    thisWeek: [
      {
        email: "yp.loo@gosumgroup.com",
        action: "create mission",
        time: "2 days ago",
        image: "https://picsum.photos/60/40?2",
      },
      {
        email: "yp.loo@gosumgroup.com",
        action: "submit mission",
        time: "4 days ago",
        image: "https://picsum.photos/60/40?3",
      },
      {
        email: "yp.loo@gosumgroup.com",
        action: "submit mission",
        time: "5 days ago",
        image: "https://picsum.photos/60/40?4",
      },
    ],
  };


  const fetchUserDetails = async (page) => {
    try {
      const apiUrl = `${mobileApiUrl}user/user-employee-details?employeeId=${id}`;
      const response = await api.get(apiUrl);
      const usersDetails = response.data.data;
      console.log(usersDetails);

      setUserDetails(usersDetails);
    } catch (error) {
      ErrorAlert(error, navigate);
    }
  };

  useEffect(() => {
    if (location.pathname.includes("edit-user")) {
      setMode("edit");
      fetchUserDetails();
    } else if (location.pathname.includes("view-details")) {
      setMode("view");
      fetchUserDetails();
    } else {
      setMode("create");
    }
  }, [location.pathname]);

  // const userDetails = userData.find((u) => u.id === Number(id));

  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            mb: 3,
          }}
        >

          <Box display="flex" justifyContent="start" alignItems="center">
            <BasicBreadcrumbs
              first={
                <Link component={RouterLink} to="/user" underline="hover" color="primary.main">
                  User Management
                </Link>
              }
              second={"View User"}
            />

            <Box sx={{ display: "flex" }}></Box>
          </Box>
        </Box>

        <Grid container spacing={8} mb={3}>
          {/* <Grid item size={{ xs: 12, md: 5 }}>
            <ActivityListing activities={activities} />
          </Grid> */}
          <Grid item size={{ xs: 12 }}>
            {/* <Box sx={{ width: "100%", mb: 1, mt: -2 }}>
                {(userDetails.role === "POISUM Admin" || userDetails.role === "Mission Creator") ? (
                <UserPointBox earnPoint={230} distributePoint={190} />
              ) :
              <Grid item size={12}>
                <UserPointBox earnPoint={110} /> </Grid>} 
              
            </Box> */}
            <Box display="flex" justifyContent="flex-end" backgroundColor="white" p={2} borderRadius={2} boxShadow={3}>
              <DetailsUserForm
                mode={mode}
                userDetails={userDetails}
                onModeChange={setMode}
                refetch={fetchUserDetails}
              />
            </Box>
          </Grid>
        </Grid>

      </Box>
      {/* </Box> */}
    </PrivateLayout>
  );
};

export default ViewDetails;
